/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsBoolResponse
 */
export interface ControlcenterMelcoModelsBoolResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoModelsBoolResponse
     */
    result?: boolean;
}

export function ControlcenterMelcoModelsBoolResponseFromJSON(json: any): ControlcenterMelcoModelsBoolResponse {
    return ControlcenterMelcoModelsBoolResponseFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsBoolResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsBoolResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ControlcenterMelcoModelsBoolResponseToJSON(value?: ControlcenterMelcoModelsBoolResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result,
    };
}


